import React from "react";
import PropTypes from "prop-types";
import Step from "../../../../atoms/Wizard/Step";
import MainInput from "../../../../atoms/Forms/MainInput";
import MainMoneyInput from "../../../../atoms/Forms/MainMoneyInput"

import styles from "./MainApp.organisms.Product.ProductSigleLoadWizard.ProductStep2.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
export class ProdStepTwo extends React.Component {

  goBackFunc = () => {
    if(this.props.goBackFunc) this.props.goBackFunc(1)
  }

  render() {
    const { product, handleChange, handleBlur, errors } = this.props;

    const stepContent = (
      <div className={styles["product-step-two-content"]} data-automation-id="input-sku">
        <div className={styles["prod-step-two-field"]}>
          <MainInput
            label={capitalize(i18n.t("code"))}
            required={true}
            id={"product-codigo"}
            name="sku"
            value={product.sku}
            handleChange={handleChange}
            maxLength={30}
            error={errors.sku}
          />
        </div>
        <div className={styles["prod-step-two-field"]} data-automation-id="input-purchase-price">
          <MainMoneyInput
            label={i18n.t("purchase_price")}
            id={"product-buyng-price"}
            name="purchase_price"
            value={product.purchase_price}
            handleChange={handleChange}
            handleBlur={handleBlur}
            maxLength={18}
            error={errors.purchase_price}
            />
        </div>
        <div className={styles["prod-step-two-field"]} data-automation-id="input-selling-price">
          <MainMoneyInput
            label={capitalize(i18n.t("sell_price"))}
            id={"product-selling-price"}
            name="sell_price"
            value={product.sell_price}
            handleChange={handleChange}
            handleBlur={handleBlur}
            maxLength={18}
            error={errors.sell_price}
            />
        </div>
      </div>
    );

    return (
      <div className={styles["product-step-two-container"]}>
        <Step title={i18n.t("step.code.price")} content={stepContent} goBackFunc={this.goBackFunc} ></Step>
      </div>
    );
  }
}

ProdStepTwo.propTypes = {
  handleChange: PropTypes.func,
};

export default ProdStepTwo;
